module.exports = __webpack_public_path__ + "static/media/view4.cebd3ee3.jpg";